import React from "react";
import { Continuebtn } from "../../Assets/CSS/Button";
import LightText from "../../Assets/CSS/Text";

const SendEmail = () => {
    return (
        <div className="container">
            <h6 style={LightText}>Subject<span className="text-danger">*</span></h6>

            <input
                type="email"
                className="form-control mb-3"
                placeholder="Enter employee email"
                style={{ borderColor: "#C8C8C8", borderRadius: "10px" }}
            />
            <h6 style={LightText}>Email Copy<span className="text-danger">*</span></h6>
            <textarea
                className="form-control mb-3"
                rows="10"
                placeholder="Write your message"
                style={{ borderColor: "#C8C8C8", borderRadius: "10px" }}
            ></textarea>

            <button className="mt-5 mb-2" style={Continuebtn} >
                Send Request
            </button>
        </div>
    );
};

export default SendEmail;
